export default __webpack_public_path__ + "images/drop-shadow.png?caa48246c4578a62adf0f49b3aaf19bd";